var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "0 0 7 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.45067776,1.62948672 L3.45067776,0 L2.68865309,0 L2.68865309,0.38340864 L2.30524445,0.38340864 L2.30524445,0 L1.05437376,0 C0.895019544,0 0.76681728,0.128202264 0.76681728,0.28755648 L0.76681728,5.84698176 C0.76681728,6.00633598 0.895019544,6.13453824 1.05437376,6.13453824 L5.08016448,6.13453824 C5.2395187,6.13453824 5.36772096,6.00633598 5.36772096,5.84698176 L5.36772096,1.9170432 L3.73823424,1.9170432 C3.58007818,1.9170432 3.45067776,1.78764278 3.45067776,1.62948672 Z M1.91584505,0.38340864 L2.29925369,0.38340864 L2.29925369,0.76681728 L1.91584505,0.76681728 L1.91584505,0.38340864 Z M2.30284814,4.98431232 C1.90506168,4.98431232 1.60791998,4.62007411 1.68699802,4.23067471 L1.92183581,3.06726912 L1.92183581,2.68386048 L2.30524445,2.68386048 L2.30524445,2.30045184 L1.92183581,2.30045184 L1.92183581,1.9170432 L2.30524445,1.9170432 L2.30524445,1.53363456 L1.92183581,1.53363456 L1.92183581,1.15022592 L2.30524445,1.15022592 L2.30524445,0.76681728 L2.68865309,0.76681728 L2.68865309,1.15022592 L2.30524445,1.15022592 L2.30524445,1.53363456 L2.68865309,1.53363456 L2.68865309,1.9170432 L2.30524445,1.9170432 L2.30524445,2.30045184 L2.68865309,2.30045184 L2.68865309,2.68386048 L2.30524445,2.68386048 L2.30524445,3.06726912 L2.57003604,3.06726912 C2.6383307,3.06726912 2.6982383,3.11639335 2.71141798,3.18348986 L2.91869827,4.23426917 C2.99538,4.62247042 2.6982383,4.98431232 2.30284814,4.98431232 L2.30284814,4.98431232 Z M2.69464385,4.34929176 C2.69464385,4.52781641 2.52091181,4.6727928 2.3064426,4.6727928 C2.09197339,4.6727928 1.9170432,4.52901456 1.9170432,4.34929176 C1.9170432,4.17076711 2.09077524,4.02579072 2.30524445,4.02579072 C2.51971366,4.02579072 2.69464385,4.17076711 2.69464385,4.34929176 L2.69464385,4.34929176 Z M5.36772096,1.46054729 L5.36772096,1.53363456 L3.8340864,1.53363456 L3.8340864,0 L3.90717367,0 C3.9838554,0 4.05694267,0.0299538 4.11085951,0.08387064 L5.28385032,1.2580596 C5.33776716,1.31197644 5.36772096,1.38506371 5.36772096,1.46054729 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid",
    transform: "translate(-113.000000, -1110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-archive",
    transform: "translate(113.000000, 1110.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#A6A6A6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Purple",
    x: 0,
    y: 0,
    width: 6.13453824,
    height: 6.13453824
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileArchive);
export default __webpack_public_path__ + "static/media/file-archive.e8de0561945007b8eb09f758f9e241fd.svg";
export { ForwardRef as ReactComponent };